import { useCallback } from 'react'
import { useAppSelector } from '../store/hooks'
import { selectAppLocale } from '../store/selectors/localeSelectors'
import { translate, type TranslationParams } from './translate'

export const useAppTranslation = () => {
    const locale = useAppSelector(selectAppLocale)

    const t = useCallback(
        (key: string, params?: TranslationParams) => translate(locale, key, params),
        [locale],
    )

    return { t, locale }
}
